import { render, staticRenderFns } from "./AgenComp.vue?vue&type=template&id=47c1cb93&scoped=true&"
import script from "./AgenComp.vue?vue&type=script&lang=js&"
export * from "./AgenComp.vue?vue&type=script&lang=js&"
import style0 from "./AgenComp.vue?vue&type=style&index=0&id=47c1cb93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1cb93",
  null
  
)

export default component.exports